module.exports = __webpack_public_path__ + "static/media/img15.dcaebc1f.png";